import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { DEFAULT_LANGUAGE } from '../../../../configs/language'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Tooltip } from '../../../common/tooltip'
import { formatText } from '../../../helpers/value'
import classes from './index.module.scss'
import PopupCopyCompany from './listCompany/popupCopyCompany'
import { changeListCheckedByArrId, selectListChecked } from './store/slice'
import { postCopyCompany } from './store/thunk'

const HeaderTitle = ({ selectPaginationInfo, hiddenSelectAll }) => {
  const dispatch = useDispatch()
  const [isShowPopup, setIsShowPopup] = useState(false)

  const paginationInfo = useSelector(selectPaginationInfo)
  const listChecked = useSelector(selectListChecked)
  const locale = useSelector((state) => state.i18n.locale)

  const allKeys = Object.keys(listChecked)
  const allValues = Object.values(listChecked)
  const numberItemChecked = allValues.filter((item) => item).length
  const hasItemChecked = numberItemChecked !== 0
  const isAllChecked = allValues.every((isChecked) => isChecked)

  const handleCopy = () => {
    setIsShowPopup(true)
  }

  const handleCheckAll = () => {
    dispatch(
      changeListCheckedByArrId({ keys: allKeys, checkedState: !isAllChecked }),
    )
  }

  const onSubmit = (listPort) => {
    dispatch(
      postCopyCompany({
        organizationIds: allKeys.filter((key) => listChecked[key]),
        targetPorfolioIds: [...listPort],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeListCheckedByArrId({ keys: allKeys, checkedState: false }),
        )
        setIsShowPopup(false)
      })
      .catch(() => {})
  }

  return (
    <>
      <div
        className={`fw600 alignItemsCenter ${
          hasItemChecked ? 'dFlex' : 'dNone'
        }`}
      >
        <span>
          {locale === DEFAULT_LANGUAGE ? <>{numberItemChecked} </> : ''}
          <Translate value="portfolio.common.SELECTED" />
          {locale === DEFAULT_LANGUAGE ? '' : <> {numberItemChecked}</>}
          <>.&nbsp; </>
        </span>
        {!hiddenSelectAll && (
          <Element
            elementName="span"
            style={{ color: '#2C73E8' }}
            className="cursorPointer"
            onClick={handleCheckAll}
          >
            {isAllChecked ? (
              <Translate value="portfolio.common.UNSELECT_ALL" />
            ) : (
              <>
                <Translate value="portfolio.common.SELECT_ALL" />
                {formatText(paginationInfo.totalRecords)}
                <Translate value="portfolio.common.ITEM" />.
              </>
            )}
          </Element>
        )}
        <Tooltip isI18n tooltipContent="portfolio.common.COPY" zIndex={13}>
          <Element
            className={classes.iconCopy}
            style={{ backgroundColor: '#F9F4E4' }}
            onClick={handleCopy}
          >
            <Icon
              style={{ color: '#FFCB1E', fontSize: 16 }}
              className="icon-folder-plus"
            />
          </Element>
        </Tooltip>
      </div>
      {isShowPopup && (
        <PopupCopyCompany
          isShow={isShowPopup}
          setShow={setIsShowPopup}
          handleApply={onSubmit}
          numberCompany={allKeys.filter((key) => listChecked[key])}
        />
      )}
    </>
  )
}

export default HeaderTitle
